import { Cookies } from 'react-cookie';
import { getSupportedLocale, getBrowserLocale, LANGUAGE_COOKIE_MAX_AGE } from './locales';

const cookies = new Cookies();

export const readLanguagePreference = () => ({
  locale: getSupportedLocale(cookies.get('language')),
  source: cookies.get('languageSource'),
});

export const saveLanguagePreference = (language, source = 'manual') => {
  const locale = getSupportedLocale(language);
  if (!locale || typeof document === 'undefined') return;
  const options = {
    path: '/',
    maxAge: LANGUAGE_COOKIE_MAX_AGE,
    sameSite: 'lax',
    secure: window.location.protocol === 'https:',
  };
  cookies.set('language', locale, options);
  cookies.set('languageSource', source, options);
};

export const initializeLanguagePreference = async detectLanguage => {
  if (typeof window === 'undefined' || readLanguagePreference().locale) return;
  // Heroku sets the cookie before delivering HTML; client-only development calls
  // the same detector through the API server before the initial render.
  const serverLocale = window.__PRELOADED_STATE__
    ? getSupportedLocale(document.documentElement.lang)
    : null;
  let detectedLocale = serverLocale;
  if (!detectedLocale && detectLanguage) {
    try {
      const result = await detectLanguage();
      detectedLocale = getSupportedLocale(result.locale);
    } catch (error) {
      // Offline or unavailable API: keep the application usable.
    }
  }
  if (!readLanguagePreference().locale) {
    const locale = detectedLocale || getBrowserLocale(navigator.languages || [navigator.language]);
    saveLanguagePreference(locale, 'auto');
  }
};

export const restoreProfileLanguage = language => {
  if (typeof window === 'undefined') return;
  const preference = readLanguagePreference();
  const profileLocale = getSupportedLocale(language);
  // Existing cookies without a source predate detection and represent manual choices.
  const hasManualChoice = preference.locale && !['auto', 'profile'].includes(preference.source);
  if (!profileLocale || hasManualChoice) return;
  saveLanguagePreference(profileLocale, 'profile');
  if (preference.locale !== profileLocale && readLanguagePreference().locale === profileLocale) {
    window.location.reload();
  }
};
